/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/FreeCellTemplate/FreeCellCardAnimator',[
		'lodash',
		'pixi',
		'util/dictionary',
		'Arkadium/GameEngine/Core/EngineManagers',
		'Arkadium/GameEngine/Scenes/Nodes/SpriteNode',
		'Arkadium/GameEngine/Tween/Tween',
		'SolitaireShared/CardLogic/CardOp',
		'CardUI/PileView',
		'CardUI/CardView',
		'CardUI/SupplyView'],
	function (_, PIXI, Dictionary, EngineManagers, SpriteNode, Tween, CardOp, PileView, CardView, SupplyView) {
		"use strict";

		var FreeCellCardAnimator = function (supplyView) {
			this.initFreeCellCardAnimator(supplyView);
		};

		FreeCellCardAnimator.prototype.initFreeCellCardAnimator = function (supplyView) {
			this.SupplyView = supplyView;
			this.AnimationList = new Dictionary(SpriteNode, Array);
			this.TweenCache = new Dictionary(SpriteNode, Tween);

			this.WinAnimator = null;

			this.IsInAnimationSet = false;
			this.DealCardNum = 0;
			this.IsDeal = false;
			this.IsUndoing = false;

			this.AnimatingAction = null;
			this.IsShuffling = false;
			this.NextAnimationDelay = 0;
			this.nextAnimationAction = null;
		};

		var ROTATION_ANGLE = Math.PI;
		var ANIMATION_LENGTH = 0.3;
		var ANIMATION_DELAY = 0.2;
		var CARD_DELAY = 0.05;

		var ANIM_LENGTH_DRAW = 0.2;
		var CARD_DELAY_DRAW = 0.1;


		FreeCellCardAnimator.AnimationEntry = function (pos, rot, scale, cardFlip, wait, speed, beforeStart) {
			this.initAnimationEntry(pos, rot, scale, cardFlip, wait, speed, beforeStart);
		};

		FreeCellCardAnimator.AnimationEntry.prototype.initAnimationEntry = function (pos, rot, scale, cardFlip, wait, speed, beforeStart) {
			this.WorldPos = pos ? pos.clone() : new PIXI.Point(0, 0);
			this.WorldRot = rot || 0;
			this.WorldScale = scale ? scale.clone() : new PIXI.Point(1, 1);
			this.CardFlip = cardFlip || 0;
			this.Wait = wait || 0;
			this.Speed = speed || 0;
			this.ForceLayer = null;
			this.ForceLayer2 = null;
			this.BeforeStart = beforeStart;
		};

		FreeCellCardAnimator.prototype.BeginAnimationSet = function (numActionsToExpect) {
			this.IsInAnimationSet = true;
			this.AnimationDelayTimer = 0;
			this.AnimationList.Clear();
			this.DealCardNum = 0;
			this.IsDeal = false;
		};

		FreeCellCardAnimator.prototype.EndAnimationSet = function () {
			this.IsInAnimationSet = false;
		};

		FreeCellCardAnimator.prototype.BeginAnimation = function (action, isUndoing) {
			if (!this.IsInAnimationSet) {
				this.AnimationDelayTimer = 0;
				this.AnimationList.Clear();
				this.DealCardNum = 0;
				this.IsDeal = false;
			}

			this.AnimatingAction = action;
			this.IsUndoing = isUndoing;
			// save the starting position for each card
			_.forEach(this.SupplyView.CardSupply.GetCardList(), function (card) {
				var cardView = this.SupplyView.GetCardView(card);
				if (!this.AnimationList.ContainsKey(cardView)) {
					// create the animation list entry
					var current = new FreeCellCardAnimator.AnimationEntry();
					current.Wait = this.AnimationDelayTimer; // starting location
					current.Speed = 0;
					//cardView.SceneTransform.Decompose(out current.WorldScale, out current.WorldRot, out current.WorldPos);
					current.WorldPos = cardView.parent.toGlobal(cardView.position);
					// TODO scale, rot

					this.AnimationList.Add(cardView, [current]);
				}
			}, this);
		};

		FreeCellCardAnimator.prototype.ContinueAnimation = function (action, opNum) {
			this.SupplyView.UpdatePileChildren(false);

			var AnimSpeed = ANIMATION_LENGTH;
			var AnimDelay = ANIMATION_DELAY;
			var CardDelaySpeed = CARD_DELAY;

			if (!this.SupplyView.CardSupply.EnforceGameRules) {
				AnimSpeed = 0.2;
				AnimDelay = 0.05;
				CardDelaySpeed = 0;
			}

			var op = action.Ops[opNum];
			if (op.Opcode == CardOp.Op.Move) {
				var fromPile = op.GetPile(CardOp.eMoveParams.SourcePile);
				var toPile = op.GetPile(CardOp.eMoveParams.DestPile);
				var numCards = op.GetNumber(CardOp.eMoveParams.NumCards);

				if (fromPile.Type == "Stock") {
					AnimSpeed = ANIM_LENGTH_DRAW;
					CardDelaySpeed = CARD_DELAY_DRAW;
				}

				if (this.IsUndoing) {
					// if undoing, swap the piles
					var tmp = fromPile;
					fromPile = toPile;
					toPile = tmp;

					CardDelaySpeed *= 0.75;
					AnimDelay *= 0.75;
					AnimSpeed *= 0.75;
				}

				var fromPileView = this.SupplyView.GetPileView(fromPile);
				var toPileView = this.SupplyView.GetPileView(toPile);
				var rev = false;
				if (numCards < 0) {
					numCards = -numCards;
					rev = true;
				}

				if (action.Ops.length > 24) {
					//AnimDelay *= 0.4; // deal
					AnimDelay *= 0.7; // deal
					//CardDelaySpeed *= 0.4;
					CardDelaySpeed *= 1;
				}

				if (numCards > 13) {
					CardDelaySpeed *= 0.1;
					this.IsDeal = true;
				} else if (numCards > 6) {
					CardDelaySpeed *= 0.25;
				}

				if (fromPileView.CardFacing == PileView.Facing.Hidden ||
					toPileView.CardFacing == PileView.Facing.Hidden) {
					AnimSpeed = 0;
					AnimDelay = 0;
					CardDelaySpeed = 0;
				} else {
					if (this.NextAnimationDelay > 0) {
						this.AnimationDelayTimer += this.NextAnimationDelay;

						this.NextAnimationDelay = 0;
					}
				}

				for (var cardNum = 0; cardNum < numCards; cardNum++) {
					var cardIdx = cardNum + 1;
					if (rev)
						cardIdx = numCards - cardNum;

					var card = toPile.NthFromTop(cardIdx);
					var cardView = this.SupplyView.GetCardView(card);

					var next = new FreeCellCardAnimator.AnimationEntry();
					next.Wait = this.AnimationDelayTimer;
					next.Speed = AnimSpeed;
					//cardView.SceneTransform.Decompose(out next.WorldScale, out next.WorldRot, out next.WorldPos);


					var cardPos = cardView.GetCardPositionInPile(null, true);
					//next.WorldPos = cardView.Parent.ToGlobal(new Vector3(cardPos.X, cardPos.Y, cardView.Z));
					next.WorldPos = cardView.Parent.toGlobal(cardPos); // TODO z order?

					if (this.IsDeal && numCards < 52) {
						next.BeforeStart = function () {
							this.SupplyView.bringPileAndCardToTop(toPileView, cardView);
						}.bind(this);
					}

					if (toPileView.CardFacing == PileView.Facing.FaceDown) {
						next.CardFlip = 1;
					} else {
						next.CardFlip = 0;
					}
					if (this.IsDeal && numCards < 52) {
						next.ForceLayer = CardView.TopLayer + 1 + card.Supply.Count - this.DealCardNum;
						next.ForceLayer2 = CardView.TopLayer + 1 + card.Supply.Count + this.DealCardNum;
						this.DealCardNum++;
					}

					if (toPile.Type == "Foundation" && !this._isUndoing) {
						var foundationGlow = new SpriteNode("foundation_effect.png");
						foundationGlow.Position = toPileView.Position;
						foundationGlow.TextureAlphaEnabled = true;
						foundationGlow.InputEnabled = false;
						foundationGlow.ScaleUniform = CardView.ScaleFactor;
						foundationGlow.Alpha = 1;

						this.SupplyView.AddChildAt(foundationGlow, 0);

						var delay = 0.15;
						var duration = 0.8;
						var scaleUp = 1.5;


						Tween.Start(foundationGlow)
							.Wait(delay)
							//.Then()
							//.FadeTo(1, 0)
							.Then()
							.ScaleTo(new PIXI.Point(scaleUp * CardView.ScaleFactor, scaleUp * CardView.ScaleFactor), duration, TWEEN.Easing.Cubic.Out)
							.And().FadeTo(0, duration, TWEEN.Easing.Cubic.Out)
							.Then()
							.Call(function (node) {
								node.Parent.RemoveChild(node);
							});

					}


					this.AnimationList.Get(cardView).push(next);

					if (numCards > 1)
						this.AnimationDelayTimer += CardDelaySpeed;
				}

				this.AnimationDelayTimer += AnimDelay;
			}
		};

		FreeCellCardAnimator.prototype.EndAnimation = function (action, callThisWhenFinished) {
			var tweensToFinish = 0;
			this.TweenCache.Clear();

			// now, actually perform all the tweens that we set up earlier
			_.forEach(this.AnimationList.GetKeys(), function (node) {
				var tweenList = this.AnimationList.Get(node);
				if (tweenList.length < 2)
					return; // no anim for this node

				if (node instanceof CardView)
					node.Animating = true;

				tweensToFinish++;

				var tween;
				if (this.TweenCache.ContainsKey(node)) {
					tween = this.TweenCache.Get(node).Then();
				} else {
					var tweens = Tween.GetTweens(node);
					if (tweens != null && tweens.length > 0)
						tween = tweens[0].Then();
					else
						tween = Tween.Start(node);

					// tween.Completed += (t, n) => TweenCache.Remove(n.Data as SceneNode); TODO
					this.TweenCache.Add(node, tween);
				}


				for (var i = 0; i < tweenList.length; i++) {
					var tweenEntry = tweenList[i];

					// First, take all of the world transform stuff and take it back to the node's local space.
					//Vector3 pos = Vector3.TransformCoordinate(tweenEntry.WorldPos, node.Parent.InverseSceneTransform);
					var pos = node.parent.toLocal(tweenEntry.WorldPos);
					//Vector3 scale = Vector3.TransformNormal(tweenEntry.WorldScale, node.Parent.InverseSceneTransform);
					var scale = tweenEntry.WorldScale; // TODO scale to local

					// Set the forced card layer before we start tweening.
					if (tweenEntry.ForceLayer != null && node instanceof CardView) {
						node.LayerWhileAnimating = tweenEntry.ForceLayer.Value;
					}

					if (i == 0) {
						node.SetPosition(pos);
						node.SetScale(scale);
					} else {
						tween = tween.Wait(tweenEntry.Wait).Then();

						if (tweenEntry.BeforeStart != null) {
							tween = tween.Call(function () {
								tweenEntry.BeforeStart();
							}).Then();
						}

						if (tweenEntry.Wait > 0 && this.nextAnimationAction != null) {
							var callAnimation = this.nextAnimationAction;
							tween = tween.Call(callAnimation).And();
							this.nextAnimationAction = null;
						}

						tween = tween.MoveTo(pos, tweenEntry.Speed, TWEEN.Easing.Quintic.Out).And()
							.ScaleTo(scale, tweenEntry.Speed, TWEEN.Easing.Quintic.Out);

						if (node instanceof CardView)
							tween = tween.And().CustomTo(
								node.SetCardFlipAngle.bind(node),
								node.GetCardFlipAngle.bind(node),
								tweenEntry.CardFlip,
								tweenEntry.Speed,
								TWEEN.Easing.Circular.Out);

					}

					tween = tween.Then();

					// Unset the forced card layer once the tween finishes.
					if (tweenEntry.ForceLayer != null) {
						tween = tween.Then().Call(function (n) {
							if (n instanceof CardView)
								n.LayerWhileAnimating = null;
						});
					}


				}

				tween = tween.Call(this.StopAnimating.bind(this));

				tween = tween.Call(function () {
					tweensToFinish = this.EndAnimTrigger(tweensToFinish, callThisWhenFinished);
				}.bind(this));
			}, this);
			this.AnimationList.Clear();
			this.TweenCache.Clear();

			//lock (AnimationLock)
			//{
			if (tweensToFinish == 0) {
				callThisWhenFinished(action);
			}
		};

		FreeCellCardAnimator.prototype.GetTweenedTimeScale = function (node, prop, timeScale) // TODO -- fix where called from to accept return param, Number not passed by ref
		{
			timeScale = EngineManagers.TimeScale;
			return timeScale;
		};

		FreeCellCardAnimator.prototype.SetTweenedTimeScale = function (node, prop, timeScale) {
			EngineManagers.TimeScale = timeScale;
		};

		FreeCellCardAnimator.prototype.StopAnimating = function (node) {
			if (node instanceof CardView)
				node.Animating = false;
		};

		// public event ShuffleFinishedDelegate OnShuffleFinished; TODO

		FreeCellCardAnimator.prototype.EndAnimTrigger = function (tweensToFinish, onComplete) {
			//lock (AnimationLock)
			//{
			tweensToFinish--;
			if (tweensToFinish == 0) {
				if (this.IsShuffling) {
					this.IsShuffling = false;
					if (this.OnShuffleFinished != null) {
						var onShuffleFinished = this.OnShuffleFinished;
						setTimeout(function () {
							onShuffleFinished();
						}, 50);
						this.OnShuffleFinished = null;
					}
				}
				if (onComplete != null) {
					onComplete(this.AnimatingAction);
				}
			}
			//}

			return tweensToFinish;
		};

		FreeCellCardAnimator.prototype.BeginShuffleAnimation = function () {
			if (this.WinAnimator != null)
				this.WinAnimator.EndAnimation();
			this.IsShuffling = true;
		};

		FreeCellCardAnimator.prototype.IsShuffleAnimationRunning = function () {
			return this.IsShuffling;
		};

		/// <summary>
		/// Instantiate and begin the win animation.
		/// </summary>
		FreeCellCardAnimator.prototype.TriggerWinAnimation = function (endAnimationCallback) {
			if (this.SupplyView.CardSupply.Authority.IsChallenge) {
				this.WinAnimator = null;
				if (endAnimationCallback != null)
					endAnimationCallback();
			} else {
				if (this.SupplyView.CurrentLayout == SupplyView.LayoutState.VerticalView) {
					if (endAnimationCallback != null)
						endAnimationCallback();
					return; // snapped, no win anim
				}

				this.WinAnimator = this.SupplyView.CreateGameEndAnimator();
				this.WinAnimator.BeginAnimation(endAnimationCallback, null, null, false); // Currently this only supports win animations that trigger when animation is complete; not ones that trigger during the movement of the last card.
			}
		};

		FreeCellCardAnimator.prototype.ShouldShowEndingPopup = function () {
			if (this.WinAnimator == null)
				return true;
			else
				return this.WinAnimator.ShouldShowEndingPopup();
		};

		FreeCellCardAnimator.prototype.DoesAnimationBlockInput = function (action) {
			return false; // nothing especially blocks input in this game
		};


		FreeCellCardAnimator.prototype.DelayNextAnimation = function (delaySeconds) {
			this.NextAnimationDelay = delaySeconds;
		};


		FreeCellCardAnimator.prototype.OnNextAnimationStart = function (action) {
			this.nextAnimationAction = action;
		};

		return FreeCellCardAnimator;

	});

